import { Header } from "@/components/Header";
import { Helmet } from "react-helmet-async";

const DMCA = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>DMCA Policy - MacroVault</title>
        <meta name="description" content="MacroVault's DMCA copyright policy and how to file a copyright notice." />
        <link rel="canonical" href="https://findmacros.com/dmca" />
      </Helmet>
      <Header />
      <main className="container mx-auto px-4 py-8 max-w-4xl">
        <h1 className="text-4xl font-bold mb-6">Copyright & DMCA</h1>
        <div className="prose prose-slate dark:prose-invert max-w-none">
          <p className="text-muted-foreground mb-4">Last updated: January 2025</p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">Copyright Policy</h2>
          <p>
            MacroFlow AI respects the intellectual property rights of others and expects our 
            users to do the same. We respond to notices of alleged copyright infringement that 
            comply with the Digital Millennium Copyright Act (DMCA).
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">Filing a DMCA Notice</h2>
          <p>
            If you believe that content on MacroFlow AI infringes your copyright, please provide 
            our Copyright Agent with the following information:
          </p>
          <ul>
            <li>A physical or electronic signature of the copyright owner</li>
            <li>Identification of the copyrighted work claimed to have been infringed</li>
            <li>Identification of the material that is claimed to be infringing</li>
            <li>Your contact information (address, telephone number, email)</li>
            <li>A statement of good faith belief that the use is not authorized</li>
            <li>A statement that the information in the notification is accurate</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8 mb-4">Counter-Notice</h2>
          <p>
            If you believe your content was removed by mistake or misidentification, you may 
            file a counter-notice with our Copyright Agent.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">Repeat Infringer Policy</h2>
          <p>
            In accordance with the DMCA and other applicable laws, we have adopted a policy 
            of terminating user accounts that are repeat infringers.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">Copyright Agent</h2>
          <p>
            Send DMCA notices to our Copyright Agent at: dmca@macroflow.ai
          </p>
        </div>
      </main>
    </div>
  );
};

export default DMCA;
